var exports = {
  "k": "x2b2fbebb--ba5903--container",
  "n": "x2b2fbebb--ba5903--link",
};

module.exports = exports;
